<template>
  <div class="container mescroll-touch">
    <div class="headerBox">
      <div class="searchBox" @click="$router.push('/search')">
        <div class="searchInput"> 
          <img class="searchIcon" src="@/assets/images/search_icon.png" />
          <span>大家都在搜</span>
        </div>
        <div class="searchBtn">搜索</div>
      </div>

      <div class="departmentBox">
        <div class="departmentListBox" ref="departmentWrapper">
          <div class="departmentList">
            <span class="departmentItem" :class="{'departmentItem_active': departmentId == item.Id}" v-for="(item, index) in departmentList" :key="index" @click="departmentChange(item.Id, item.Code, item.TCode, item.DisplayName)">
              {{ item.DisplayName }}<template v-if="departmentId == item.Id && firstTechniqueName">-{{firstTechniqueName}}...</template>
              <van-icon v-if="departmentId == item.Id" class="expandIcon" name="play" />
              <div class="tips" v-if="showTips && departmentId == item.Id">
                <span>可点击筛选二级科室</span>
              </div>
            </span>
          </div>
        </div>
        <div class="moreDepartment">
          <span @click="$router.push('/interest')">{{userInfo.Type != 3 ? '更多...' : 'More...'}}</span>
        </div>
      </div>

      <div class="techniqueBox" v-if="techniqueShow">
        <div class="techniqueList">
          <span :class="{'technique_active': techniqueActiveListTemp.indexOf(0) !== -1}" @click="selectTechnique(0, code + '|', '全部')">All</span>
          <span :class="{'technique_active': techniqueActiveListTemp.indexOf(parseInt(item.Value)) !== -1}" v-for="item in techniqueList" :key="item.Value" @click="selectTechnique(item.Value, item.TCcode, item.Name)">{{ item.Name }}</span>
        </div>
        <div class="btnBox">
          <div class="resetBtn" @click="resetTechnique">重置</div>
          <div class="confirmBtn" @click="confirmTechnique">确定</div>
        </div>
      </div>
    </div>
    <div class="contentBox" id="toTop">
      <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="bannerBox" v-if="bannerList.length > 0">
        <swiper class="bannerSwiper" ref="bannerSwiper" :options="bannerSwiperOptions" @click="(event) => handleBannerClick(event)">
          <swiper-slide v-for="(item, index) in bannerList" :key="index">
            <img :src="item.File_Url" alt="" srcset="">
          </swiper-slide>
        </swiper>
      </div>

      <div class="columnBox">
        <div class="columnList" :class="{'columnTop': bannerList.length == 0}" v-if="columnList1.length > 0">
          <div class="columnItem" v-for="(item, index) in columnList1" :key="index" @click="selectColumns(item.Type, item.Link, item.Name, item.Id)">
            <img :src="item.Icon" />
            <span>{{ item.Name }}</span>
          </div>
        </div>
        <div class="columnList" v-if="columnList2.length > 0">
          <div class="columnItem" v-for="(item, index) in columnList2" :key="index" @click="selectColumns(item.Type, item.Link, item.Name, item.Id)">
            <img :src="item.Icon" />
            <span>{{ item.Name }}</span>
          </div>
        </div>
      </div>

      <div class="recentActivitiesBox" v-show="liveList.length > 0">
        <div class="titleBox">
          <span class="title">近期活动</span>
          <span class="moreActivities" @click="moreActivities()">更多活动<img class="arrow" src="@/assets/images/right-arrow.png"></span>
        </div>
        <div class="recentActivitiesWrapper" ref="recentActivitiesWrapper">
          <div class="recentActivitiesList">
            <div class="recentActivitiesItem" v-for="(item, index) in liveList" :key="index" @click="toContentPage(item.Id, item.Type)">
              <div class="activitieCover">
                <img :src="item.Thumbnail" />
                <div class="activitieStatus liveStreaming" v-if="item.LiveStatus == 1">
                  <img src="@/assets/images/live1.png" />
                  <span>进行中</span>
                </div>
                <div class="activitieStatus noLive" v-if="item.LiveStatus == 2">
                  <img src="@/assets/images/notLive.png" />
                  <span>未开始</span>
                </div>
              </div>
              <div class="activitieInfo">
                <p class="activitieTitle van-multi-ellipsis--l2">{{ item.Title }}</p>
                <p class="activitieTime">开始时间：{{ item.StartTime.replace('T', ' ') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ListBox">
        <div class="filterBox">
          <div class="filterItem" :class="{'filterItem_active': ModuleType == 1}" @click="moduleTypeChange(1)">
            <img class="new_icon" src="@/assets/images/new_icon1.png">
            <span>{{userInfo.Type != 3 ? '最新' : 'New'}}</span>
          </div>
          <div class="filterItem" :class="{'filterItem_active': ModuleType == 2}" @click="moduleTypeChange(2)">
            <img class="hot_icon" src="@/assets/images/hot_icon1.png">
            <span>{{userInfo.Type != 3 ? '热门' : 'Hot'}}</span>
          </div>
        </div>
        <div class="list" id="dataList" ref="masonryList" :key="listKey" v-masonry gutter="12" item-selector=".listItem" column-width=".listItem" transition-duration="0">
          <div v-masonry-tile class="listItem" v-for="(item, index) in list" :key="index" @click="toContentPage(item.Id, item.Type)">
            <div class="item_img">
              <img class="item_cover" :src="item.Thumbnail" />
              <img class="playIcon" v-if="item.Type == 1 || item.Type == 3" src="@/assets/images/play_icon.png" />
            </div>
            <div class="item_content">
              <span class="item_title van-multi-ellipsis--l2">{{item.Title}}</span>
              <div class="doctor_info" v-if="item.Speaker || item.HospitalName">
                <img src="@/assets/images/headSculpture1.png">
                <span>{{item.Speaker}} {{item.HospitalName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </mescroll-vue>
    </div>
  </div>    
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import { mapState } from 'vuex'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'Department',
  data() {
    return {
      code: '',
      departmentId: '',
      departmentList: [],
      showTips: false,
      techniqueShow: false,
      techniqueList: [],
      techniqueActiveList: [0],
      techniqueActiveListTemp: [0],
      bannerList: [],
      bannerSwiperOptions: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        simulateTouch: true,
        touchRatio: 1,
        speed: 500,
        effect: 'slide',
        slideToClickedSlide: true,
      },
      columnList1: [],
      columnList2: [],
      liveList: [],
      ModuleType: 1,
      list: [],
      listKey: 0, // 强制重建v-masonry容器用：修复返回/切换科室后出现的单侧(单列)布局
      PageIndex: 0,
      PageSize: 6,
      scrollTop: 0, // 记录离开页面时的滚动位置，用于返回时恢复
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 10 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_icon_1103.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '暂无内容', // 提示
        },
			},
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    ...mapState(['userInfo']),
    sid() {
      return this.$route.query.sid;
    },
    firstTechniqueName() {
      if(this.techniqueActiveList.length > 0 && this.techniqueActiveList[0] != 0) {
        const firstTechnique = this.techniqueList.find(item => item.Value == this.techniqueActiveList[0]);
        return firstTechnique ? firstTechnique.Name.slice(0, 3) : '';
      } else {
        return ''
      }
    }
  },
  watch: {
    departmentList() {
      this.$nextTick(() => {
        this.departmentScroll.refresh();
        let el = document.querySelector(".departmentItem_active");
        this.departmentScroll.scrollToElement(el, 0, 0);
      })
    },
    // 激活科室后面追加了"-术式名..."导致文本变宽后，需重新计算 BScroll 滚动范围，
    // 否则滑动到最末尾时"-xxx..."会被截断显示不全
    firstTechniqueName() {
      this.$nextTick(() => {
        if (this.departmentScroll) {
          this.departmentScroll.refresh();
          const el = document.querySelector(".departmentItem_active");
          if (el) {
            this.departmentScroll.scrollToElement(el, 0, 0);
          }
        }
      })
    },
    ModuleType() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    departmentId() {
      this.getBanner();
      this.getColumnList();
      this.getLiveList();
      this.getTechnique();
      this.list = [];
      this.mescroll.resetUpScroll();
      this.BuriedPoint(6, '科室首页', `${this.code}|`, `/department?id=${this.departmentId}&code=${this.code}`, this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    }
  },
  created() {
    if(this.$route.query.id) {
      this.departmentId = this.$route.query.id;
    }
    if(this.$route.query.code) {
      this.code = this.$route.query.code;
    }
    if(this.sid) { 
      this.$set(this.techniqueActiveList, 0, parseInt(this.sid));
    }

    this.getDepartment();
    // 是否显示可点击筛选二级科室提示
    this.$axios.post('/Api/Api/Web/Customer/GetUserIsFollow', {
      type: 5
    }).then(res => {
      this.showTips = res.Data ? false : true;
    })
    // this.getBanner();
    // this.getColumnList();
    // this.getLiveList();
    // this.getTechnique();
  },
  mounted() {
    this.initDepartmentBScroll();
    this.initRecentActivitiesBScroll();
  },
  activated(){
    wx.miniProgram.postMessage({
      data: {
        share: {
          title: '科室首页',
          imageUrl: '',
          path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/department?id=${this.departmentId}&code=${this.code}&sourceType=7`)}`,
          contentId: ''
        }
      }
    })
    
    // if(this.departmentId && this.code) {
    //   this.BuriedPoint(6, '科室首页', `${this.code}|`, `/department?id=${this.departmentId}&code=${this.code}`, this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    // }  
    this.$store.commit('changeNavbarIndex', 0);

    if(this.scrollTop > 0 && this.$refs.mescroll) {
      this.$refs.mescroll.$el.scrollTop = this.scrollTop;
    }

    this.$nextTick(() => {
      this.checkMasonryLayout();
      // 从其他页面返回时，缓存页里的 banner 轮播最右侧图片可能出现空白（详见 refreshBannerSwiper）
      this.refreshBannerSwiper();
    });
  },
  // 页面被 vue-page-stack 缓存(display:none)时停止 banner 自动轮播，避免隐藏期间轮播状态漂移
  deactivated() {
    const swiper = this.$refs.bannerSwiper && this.$refs.bannerSwiper.$swiper;
    if (swiper && swiper.autoplay) {
      swiper.autoplay.stop();
    }
  },
  methods: {
    // 初始化科室BScroll
    initDepartmentBScroll() {
      this.$nextTick(() => {
        this.departmentScroll = new BScroll(this.$refs['departmentWrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    // 初始化近期活动BScroll
    initRecentActivitiesBScroll() {
      this.$nextTick(() => {
        this.recentActivitiesScroll = new BScroll(this.$refs['recentActivitiesWrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    // 获取科室
    getDepartment() {
      this.$axios.post('/Api/Api/Web/Subject/GetUserDepartmentList?WebCode=' + sessionStorage.getItem('random')).then(res => {
        this.departmentList = res.Data;
        if(!this.departmentId || !this.code) {
          const department = this.departmentList.find(item => item.DisplayName == this.userInfo.SubjectName);
          if(department) {
            this.departmentId = department.Id;
            this.code = department.Code;
          }
        }

        // 数据渲染完成后重新计算滚动范围
        this.$nextTick(() => {
          this.departmentScroll && this.departmentScroll.refresh();
        })
      })
    },
    // 获取术式
    getTechnique() {
      this.$axios.post('/Api/Api/Web/Customer/GetDitWebCode?type=2&pcode=' + this.code).then(res => {
        this.techniqueList = res.Data;
      })
    },
    // 获取Banner
    getBanner() {
      this.$axios.post('/Api/api/Web/ImgFile/GetImgFileListByCode', {
        PageType: 1,
        Code: this.code
      }).then(res => {
        this.bannerList = res.Data;

        if (this.bannerList.length === 1) {
          const copy = JSON.parse(JSON.stringify(this.bannerList[0]));
          this.bannerList.push(copy);
        }
      })
    },
    getColumnList() {
      this.$axios.post('/Api/api/Web/Column/GetColumnList', {
        SubId: this.departmentId
      }).then(res => {
        this.columnList1 = res.Data.lst1;
        this.columnList2 = res.Data.lst2;
      })
    },
    getLiveList() {
      this.$axios.post('/Api/api/Web/Article/GetSLList', {
        SubId: this.departmentId
      }).then(res => {
        this.liveList = res.Data;
        this.$nextTick(() => {
          this.recentActivitiesScroll && this.recentActivitiesScroll.refresh();
        })
      })
    },
    departmentChange(id, code, tcode, name) {
      if(this.departmentId != id) {
        let url = `/department?id=${id}&code=${this.code}`;
        this.BuriedPoint(1, name, tcode, url);
        this.$router.push({
          path: 'department',
          query: {
            id: id,
            code: code
          }
        })
      } else {
        this.techniqueShow = !this.techniqueShow;
        this.techniqueActiveListTemp = JSON.parse(JSON.stringify(this.techniqueActiveList));

        if(this.showTips) {
          this.showTips = false;
          this.$axios.post('/Api/Api/Web/Customer/AddUserIsFollow', {
            type: 5
          }).then(res => {})
        }
      }
    },
    selectTechnique(id, TCcode, name) {
      const index = this.techniqueActiveListTemp.indexOf(parseInt(id));
      
      if (id === 0) {
        // 如果选择"全部"，清空其他科室，只保留全部
        if (index !== -1) {
          this.techniqueActiveListTemp = [];
        } else {
          this.techniqueActiveListTemp = [0];
          this.BuriedPoint(1, name, TCcode, `/department?id=${this.departmentId}&code=${this.code}`);
        }
      } else {
        // 如果选择其他科室，取消"全部"的选中状态
        const allIndex = this.techniqueActiveListTemp.indexOf(0);
        if (allIndex !== -1) {
          this.techniqueActiveListTemp.splice(allIndex, 1);
        }
        
        if (index !== -1) {
          this.techniqueActiveListTemp.splice(index, 1);
        } else {
          this.techniqueActiveListTemp.push(parseInt(id));
          this.BuriedPoint(1, name, TCcode, `/department?id=${this.departmentId}&code=${this.code}`);
        }
      }
    },
    resetTechnique() {
      this.techniqueActiveList = [0];
      this.techniqueActiveListTemp = [0];
    },
    confirmTechnique() {
      this.techniqueActiveList = JSON.parse(JSON.stringify(this.techniqueActiveListTemp));
      this.techniqueShow = false;

      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    handleBannerClick(event) {
      const realIndex = event.realIndex;
      const info = this.bannerList[realIndex];
      if(info.LinkType && info.UrlLink) {
        if(info.LinkType == 1) {
          location.href = info.UrlLink;
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.UrlLink})
        } else if(info.LinkType == 3) {
          if (info.UrlLink.indexOf('?') !== -1) {
            info.UrlLink += '&sourceType=3&sourceId=' + info.Id;
          } else {
            info.UrlLink += '?sourceType=3&sourceId=' + info.Id;
          }
          this.$router.push(info.UrlLink);
        }
        this.BuriedPoint(3, info.DepartmentName, info.DepartmentCode, info.UrlLink, info.Id);
      }
    },
    // 从其他页面返回(缓存页重新显示)时刷新 banner 轮播。
    // 页面被 vue-page-stack 以 display:none 缓存时，WebView 会停止轮播区域的绘制，
    // 返回后最右侧图片可能仍停留在旧的绘制结果上显示为空白，直到轮播一次触发重绘才恢复。
    // 这里重建 loop 复制项并立即动画轮播一格，主动触发一次重绘，避免用户看到空白。
    refreshBannerSwiper() {
      const swiper = this.$refs.bannerSwiper && this.$refs.bannerSwiper.$swiper;
      if (!swiper || !swiper.initialized || this.bannerList.length < 1) return;

      // 1. 重建 loop 辅助 slide(参照 vue-awesome-swiper 对 keep-alive 场景的 autoReLoopSwiper)
      if (swiper.loopDestroy) swiper.loopDestroy();
      if (swiper.loopCreate) swiper.loopCreate();
      swiper.update();

      // 2. 回到缓存前所在的轮播位置
      swiper.slideToLoop(swiper.realIndex, 0, false);

      // 3. 立即动画轮播一格：强制 WebView 对整个轮播行重绘(等价于手动轮播一次的效果)
      swiper.slideNext();

      // 4. 恢复自动轮播(deactivated 时已 stop，start 内部幂等)
      if (swiper.autoplay) {
        swiper.autoplay.start();
      }
    },
    // 选择栏目
    selectColumns(type, url, name, id) {
      if(type, url) {
        if(type == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(url)) {
            location.href = url;
          } else {
            this.$router.push(url);
          }
        } else if(type == 2) {
          wx.miniProgram.navigateTo({url: url})
        } else if(type == 3) {
          if (url.includes('zonePage')) {
            this.$router.push(url + (url.includes('?') ? '&' : '?') + `departmentId=${this.departmentId}&sourceType=15&sourceId=${id}`);
          } else {
            this.$router.push(url + (url.includes('?') ? '&' : '?') + `sourceType=15&sourceId=${id}`);
          }
        }
      }
      this.BuriedPoint(1, name, '', `/department?id=${this.departmentId}&code=${this.code}`);
    },
    moreActivities() {
      this.$router.push({
        path: 'liveList',
        query: {
          id: this.departmentId,
          code: this.code
        }
      })
    },
    moduleTypeChange(type) {
      if(this.ModuleType != type) {
        this.ModuleType = type;
      }
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      this.$refs.mescroll.$el.addEventListener('scroll', () => {
        this.scrollTop = this.$refs.mescroll.$el.scrollTop
      })
		},
    // v-masonry在从缓存页返回/切换科室重新激活时，偶发会退化为单列(单侧)布局，
    // 先触发重排，若检测到多张卡片仍处于同一水平位置，则强制重建瀑布流容器
    checkMasonryLayout() {
      if (this.$redrawVueMasonry) {
        this.$redrawVueMasonry();
      }
      this.$nextTick(() => {
        const container = this.$refs.masonryList;
        if (!container) return;
        const tiles = container.querySelectorAll('.listItem');
        if (tiles.length <= 1) return;
        const leftSet = new Set();
        tiles.forEach(tile => {
          leftSet.add(Math.round(tile.getBoundingClientRect().left));
        });
        // 卡片多于1张却只有一个水平位置 => masonry未生效(单列排布)，重建容器
        if (leftSet.size === 1) {
          this.listKey += 1;
          this.$nextTick(() => {
            if (this.$redrawVueMasonry) {
              this.$redrawVueMasonry();
            }
          });
        }
      });
    },
    // 上拉回调
		upCallback (page) {
      if(this.departmentId) {
        this.getList(page.num, page.size);
      }
		},
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;

      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetArticleList', {
          SubId: parseInt(this.departmentId),
          ModuleType: this.ModuleType,
          Code: '',
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          SId: this.techniqueActiveList.indexOf(0) !== -1 ? [] : this.techniqueActiveList,
          IsShowLive: false
        }).then(res => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
            // 首屏数据渲染完成后检查瀑布流布局是否正常
            if (PageIndex === 1) {
              this.checkMasonryLayout()
            }
          })
        })
      }, 300);
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type
          }
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .mescroll {
    padding-bottom: 60px;
    box-sizing: border-box;
  }
  .headerBox {
    position: relative;
    z-index: 9;
    height: 73px;
    padding-top: 10px;
    background-color: #EB1700;
    box-shadow: 0 4px 12px -4px rgba(159, 0, 0, 0.3);
    box-sizing: border-box;
    .searchBox {
      position: absolute;
      z-index: 1;
      left: 10px;
      right: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 28px;
      border-radius: 28px;
      background-color: #FFFFFF;
      padding: 0 3px 0 10px;
      box-sizing: border-box;
      // margin: 0 10px;
      .searchInput {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #CACACA;
      }
      .searchIcon {
        display: block;
        width: 12px;
        margin-right: 5px;
      }
      .searchBtn {
        width: 40px;
        height: 22px;
        border-radius: 22px;
        text-align: center;
        line-height: 22px;
        font-size: 11px;
        color: #FFFFFF;
        background-color: #EB1700;
      }
    }
    .departmentBox {
      position: relative;
      z-index: 9;
      top: 21px;
      height: 42px;
      line-height: 52px;
      margin-right: 10px;
      overflow: hidden;
      .departmentListBox {
        display: flex;
        overflow: hidden;
        margin-right: 40px;
      }
      .departmentList {
        white-space: nowrap;
        .departmentItem {
          position: relative;
          font-size: 14px;
          color: #FFFFFF;
          padding: 0 10px;
          .expandIcon {
            font-size: 9px;
            transform: translateY(-2px) rotate(90deg);
          }
          .tips {
            position: absolute;
            z-index: 9;
            top: -15px;
            right: -69px;
            width: 106PX;
            height: 24PX;
            background-image: url('../../assets/images/popover.png');
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 8px;
            span {
              color: #4A4A4A;
              opacity: 0.9;
            }
          }
        }
        .departmentItem_active {
          font-size: 15px;
          font-weight: bold;
        }
        .departmentItem_active::after {
          content: "";
          display: block;
          width: 60%;
          height: 4px;
          border-radius: 4px;
          background-color: #FFFFFF;
          position: absolute;
          bottom: -8px;
          left: 20%;
        }
      }
      .moreDepartment {
        position: absolute;
        width: 58px;
        height: 30px;
        line-height: 30px;
        top: 11px;
        right: 0px;
        font-size: 12px;
        color: #FFFFFF;
        text-align: right;
        background: linear-gradient(to right, transparent 0%, #EB1700 50%);
        z-index: 9;
      }
    }
    .techniqueBox {
      position: absolute;
      z-index: 8;
      top: 100%;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      padding: 8px 10px 15px;
      box-sizing: border-box;
      border-radius: 0 0 16px 16px;
      box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.1);
      .techniqueList {
        display: flex;
        flex-wrap: wrap;
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 23%;
          height: 28px;
          line-height: 28px;
          border-radius: 28px;
          background-color: #FFFFFF;
          border: 1px solid #D1D2D9;
          font-size: 12px;
          color: #4A4A4A;
          box-sizing: border-box;
          margin-top: 10px;
        }
        span:not(:nth-child(4n)) {
          margin-right: calc(8% / 3);
        }
        .technique_active {
          border: 1px solid #EB1700;
          color: #EB1700;
        }
      }
      .btnBox {
        display: flex;
        margin-top: 12px;
        .resetBtn {
          width: 80px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          font-size: 14px;
          color: #EB1700;
          background-color: #FFFFFF;
          border-radius: 35px;
          margin-right: 15px;
          box-shadow: 0 3px 10px -4px rgba(0, 0, 0, 0.2);
        }
        .confirmBtn {
          flex: 1;
          height: 35px;
          line-height: 35px;
          text-align: center;
          font-size: 14px;
          color: #FFFFFF;
          background-color: #EB1700;
          border-radius: 35px;
          box-shadow: 0 3px 10px -4px rgba(235, 23, 0, 0.3);
        }
      }
    }
  }
  .contentBox {
    flex: 1;
    height: 0;
    .bannerBox {
      margin: 6px 0;
      overflow: hidden;
      .bannerSwiper {
        padding: 0 15px;
        overflow: visible;
        ::-webkit-scrollbar {
          display: none;
        }
        ::v-deep .swiper-slide {
          width: 92%;
          margin: 0 auto;
          transition: transform 0.3s, opacity 0.3s;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
          border-radius: 12px;
          img {
            display: block;
            width: 100%;
            object-fit: cover;
            border-radius: 12px;
          }
        }
        ::v-deep .swiper-slide:not(.swiper-slide-active) {
          transform: scale(0.94);
        }
      }
    }
    .columnBox {
      width: 100%;
      padding: 0 12px;
      box-sizing: border-box;
      .columnList {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .columnItem {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 25%;
          img {
            display: block;
            width: 35px;
            margin: 0 auto;
          }
          span {
            display: inline-block;
            font-size: 12px;
            color: #3D3D3D;
            margin: 0;
          }
        }
      }
      .columnTop {
        margin-top: 10px;
      }
    }
    .recentActivitiesBox {
      padding: 7px 0;
      background-color: #F4F4F4;
      .titleBox {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        color: #4A4A4A;
        .title {
          font-size: 12px;
          font-weight: bold;
        }
        .moreActivities {
          display: flex;
          align-items: center;
          font-size: 10px;
          .arrow {
            display: block;
            width: 4px;
            margin-left: 4px;
          }
        }
      }
      .recentActivitiesWrapper {
        margin-top: 5px;
        overflow: hidden;
      }
      .recentActivitiesList {
        display: inline-flex;
        flex-wrap: nowrap;
        min-width: 100%;
        .recentActivitiesItem {
          display: flex;
          flex-shrink: 0;
          width: 332px;
          background-color: #FFFFFF;
          padding: 5px;
          border-radius: 6px;
          margin-right: 5px;
          .activitieCover {
            position: relative;
            width: 140px;
            border-radius: 6px;
            margin-right: 8px;
            overflow: hidden;
            img {
              display: block;
              width: 100%;
            }
            .activitieStatus {
              display: flex;
              align-items: center;
              position: absolute;
              left: 5px;
              bottom: 5px;
              height: 15px;
              border-radius: 15px;
              padding: 0 5px;
              font-size: 8px;
              img {
                display: block;
                width: 9px;
                margin-right: 2px;
              }
            }
            .noLive {
              background-color: #D8D8D8;
              color: #000000;
            }
            .liveStreaming {
              background-color: #EB1700;
              color: #FFFFFF;
            }
          }
          .activitieInfo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            padding: 2px 0;
            .activitieTitle {
              font-size: 12px;
              color: #3D3D3D;
            }
            .activitieTime {
              font-size: 10px;
              color: #9E9E9E;
            }
          }
        }
        .recentActivitiesItem:first-of-type {
          margin-left: 15px;
        }
        .recentActivitiesItem:last-of-type {
          margin-right: 15px;
        }
      }
    }
    .ListBox {
      .filterBox {
        display: flex;
        height: 35px;
        padding: 0 15px;
        border-bottom: 1px solid #F4F4F4;
        overflow: hidden;
        .filterItem {
          position: relative;
          display: flex;
          align-items: center;
          height: 36px;
          margin-right: 15px;
          .new_icon {
            display: block;
            width: 10px;
          }
          .hot_icon {
            display: block;
            width: 8px;
          }
          span {
            font-size: 15px;
            color: #3D3D3D;
            margin-left: 4px;
          }
        }
        .filterItem_active {
          span {
            color: #4A4A4A;
            font-weight: bold;
          }
        }
        .filterItem_active::after {
          content: "";
          width: 100%;
          height: 4px;
          border-radius: 4px;
          background-color: #EB1700;
          position: absolute;
          top: 32px;
          left: 0;
        }
      }
      .list {
        margin: 10px 14px 0;
        box-sizing: border-box;
        .listItem {
          width: calc(50% - 6px);
          background-color: #FFFFFF;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 12px;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px;
          .item_img {
            position: relative;
            .item_cover {
              display: block;
              width: 100%;
            }
            .playIcon {
              position: absolute;
              right: 3px;
              bottom: 3px;
              width: 20px;
              height: 20px;
            }
          }
          .item_content {
            color: #564C47;
            .item_title {
              font-size: 12px;
              color: #3D3D3D;
              padding: 0 5px;
              margin: 5px 0;
            }
            .doctor_info {
              display: flex;
              align-items: flex-start;
              font-size: 10px;
              line-height: 14px;
              border-top: 1px solid #F4F4F4;
              padding: 5px;
              img {
                display: block;
                width: 18px;
                margin-right: 4px;
              }
              span {
                color: #979797;
              }
            }
          }
        }
      }
    }
  }
}
</style>